<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewRelationshipForm = !showNewRelationshipForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewRelationshipForm, 'fa-minus-circle': showNewRelationshipForm }"></i>&nbsp;New Relationship</h6>
  <div class="card-body" [hidden]="!showNewRelationshipForm" style="max-height: 340px; overflow-y: scroll">
    <ng-container [ngTemplateOutlet]="relationshipForm" [ngTemplateOutletContext]="{ relationship: newRelationship }"> </ng-container>
  </div>
</div>
<div class="py-1"></div>
<div class="float-right">
  <button type="button" [disabled]="loadingRelationships" (click)="loadRelationships()" class="btn btn-outline-primary btn-sm">
    <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingRelationships }"></i>
  </button>
</div>
<div class="clearfix"></div>
<div class="py-1"></div>
<table class="table table-sm">
  <tbody>
    <tr *ngFor="let relationship of relationships; let i = index">
      <td *ngIf="!relationship.editing">
        <div class="btn-group btn-group-sm">
          <button title="Edit" (click)="relationship.editing = true" type="button" class="btn btn-outline-primary btn-sm">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button title="Delete" (click)="deleteRelationship(relationship, i)" type="button" class="btn btn-outline-danger btn-sm">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </td>
      <td *ngIf="!relationship.editing">
        <a [routerLink]="'/contacts/' + relationship.related_id">
          {{ relationship.name }}
        </a>
      </td>
      <td *ngIf="!relationship.editing">
        {{ relationship.role }}
      </td>
      <td *ngIf="relationship.editing" colspan="3">
        <h6 class="font-italic text-info">Editing Relationship</h6>
        <ng-container [ngTemplateOutlet]="relationshipForm" [ngTemplateOutletContext]="{ relationship: relationship }"> </ng-container>
      </td>
    </tr>
  </tbody>
</table>
<ng-template #relationshipForm let-relationship="relationship">
  <div class="form-group">
    <label>Relation Type</label>
    <select required class="form-control form-control-sm" name="relation_id" ngDefaultControl [(ngModel)]="relationship.relation_id">
      <option *ngFor="let relationshipType of formOptions.relationship_types" [value]="relationshipType.value">
        {{ relationshipType.label }}
      </option>
    </select>
    <div class="invalid-feedback d-block" *ngIf="!relationship.relation_id && relationship.formSubmitted">Relation type is required</div>
  </div>
  <div class="form-group">
    <label>Related Contact</label>
    <app-contact-search [small_input]="true" [contactId]="relationship.related_id" (contact_id)="relationship.related_id = $event"></app-contact-search>
    <div class="invalid-feedback d-block" *ngIf="!relationship.related_id && relationship.formSubmitted">Related contact is required</div>
  </div>
  <div class="form-row">
    <div class="col-6">
      <button type="button" class="btn btn-primary btn-sm btn-block" [disabled]="relationship.formSubmitting" (click)="saveRelationship(relationship)">Save</button>
    </div>
    <div class="col-6">
      <button type="button" class="btn btn-outline-secondary btn-sm btn-block" [disabled]="relationship.formSubmitting" (click)="relationship.id ? (relationship.editing = false) : (showNewRelationshipForm = false)">Cancel</button>
    </div>
  </div>
</ng-template>
